/**
 * Focus Styles Configuration
 * Singleton config for all focus border styling across the application.
 * 
 * USAGE:
 * import { FOCUS_BORDER } from '../../config/focusStyles';
 * 
 * // In component styles or CSS props:
 * border: focused ? FOCUS_BORDER.active : FOCUS_BORDER.inactive,
 */

export const FOCUS_CONFIG = {
    color: '#b21f1f',    // White/off-white focus color
    width: '4px',        // Border width
    style: 'solid',      // Border style
};

export const FOCUS_BORDER = {
    // Active (focused) state - visible border
    active: `${FOCUS_CONFIG.width} ${FOCUS_CONFIG.style} ${FOCUS_CONFIG.color}`,

    // Inactive (unfocused) state - transparent border to maintain layout
    inactive: `${FOCUS_CONFIG.width} ${FOCUS_CONFIG.style} transparent`,

    // For elements that shouldn't show any border when unfocused
    none: 'none',
};

// Helper function for dynamic color (rare cases)
export function getFocusBorder(color = FOCUS_CONFIG.color, width = FOCUS_CONFIG.width) {
    return `${width} solid ${color}`;
}
